/**
 * @generated SignedSource<<c5fdc6c2c92dfa77e34e204ab2c3a819>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SignOutPayload",
    "kind": "LinkedField",
    "name": "signOut",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "redirectUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SignOutMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SignOutMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "4551e8c98c573b25df10473950300af5",
    "id": null,
    "metadata": {},
    "name": "SignOutMutation",
    "operationKind": "mutation",
    "text": "mutation SignOutMutation {\n  signOut {\n    success\n    redirectUrl\n  }\n}\n"
  }
};
})();

node.hash = "03ae4815d62a65476dd7981068d91760";

module.exports = node;
